export const getMainImagesWebUrl = "/inventory/getMainImagesWeb";
export const addMainImageUrl = "/inventory/addMainImage";
export const deleteInventoryImageUrl = "/inventory/deleteInventoryImage";
export const addSliderImagesUrl = "/inventory/addSliderImages";
export const deleteInventoryItemUrl = "/inventory/deleteInventoryItem/{reference}";
export const getSpecificInventoryUrl = "/inventory/getSpecificInventory/{reference}";
export const exportImagesLastUpdateExcelUrl = "/inventory/exportImagesLastUpdateExcel";

